// extracted by mini-css-extract-plugin
module.exports = {"hidingHeader":"SecondaryLinksItem_hidingHeader__cUBm_","hidingHeader-in":"SecondaryLinksItem_hidingHeader-in__5hXzH","wrapper":"SecondaryLinksItem_wrapper__tDDbE"};